import type { ReactNode } from 'react'
import { useIsAdmin } from '@/features/auth/useIsAdmin'
import { FullScreenLoader } from '@/features/auth/routes/FullScreenLoader'
import { NoAccess } from './NoAccess'

export const AdminOnly = ({ children }: { children: ReactNode }) => {
  const { isAdmin, isLoading } = useIsAdmin()
  if (isLoading) return <FullScreenLoader />
  if (!isAdmin) return <NoAccess />
  return <>{children}</>
}
